import React, { useState } from 'react'
import useEventCallback from './useEventCallback'
import s from './SwitchInput.less'
import classNames from 'classnames'
import useEffectExceptMount from './useEffectExceptMount'

const SwitchInput = ({ onChange, defaultValue = false }) => {
  const [value, setValue] = useState(defaultValue)

  useEffectExceptMount(() => {
    onChange(value)
  }, [value])

  const onClick = useEventCallback(() => {
    setValue(!value)
  }, [value])

  return (
    <div onClick={onClick} className={classNames(s.root, value && s.active)}>
      <div className={s.button} />
    </div>
  )
}

export default SwitchInput
